import { render, staticRenderFns } from "./FormNote.vue?vue&type=template&id=65648d42&"
import script from "./FormNote.vue?vue&type=script&lang=js&"
export * from "./FormNote.vue?vue&type=script&lang=js&"
import style0 from "./FormNote.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports